<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <p
        data-slot="field-description"
        :class="
            cn(
                'text-content-tertiary text-sm leading-normal font-normal group-has-[[data-orientation=horizontal]]/field:text-balance',
                'last:mt-0 nth-last-2:-mt-1 [[data-variant=legend]+&]:-mt-1.5',
                '[&>a:hover]:text-primary [&>a]:underline [&>a]:underline-offset-4',
                'group-has-disabled/field:text-content-subdued',
                'group-has-data-[slot=field-error]/field:hidden',
                props.class,
            )
        "
    >
        <slot />
    </p>
</template>
